module.exports = __webpack_public_path__ + "media/application/images/2018/email-blue@2x-53041eac1cb8097fce9c67d9687f7af6.png";